import { render, staticRenderFns } from "./crmcustomers.vue?vue&type=template&id=68ba109a&scoped=true&"
import script from "./crmcustomers.vue?vue&type=script&lang=js&"
export * from "./crmcustomers.vue?vue&type=script&lang=js&"
import style0 from "./crmcustomers.vue?vue&type=style&index=0&id=68ba109a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ba109a",
  null
  
)

export default component.exports